export default "__VITE_ASSET__B8PST513__"